module.exports = __webpack_public_path__ + "static/media/raduno1965.2169c64e.jpg";